import { Metric } from 'src/graphql';

export const getMetricName = (metric?: Metric): string | null | undefined =>
  metric?.name === 'Revenue - Recurring % (Accounting)'
    ? 'Revenue Mix - % Recurring'
    : metric?.name;
